"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIceServerConfig = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../../helpers");
const constants_1 = require("../../constants");
const CryptoJS = require("crypto-js");
const axiosUtil_1 = require("../../utils/axiosUtil");
const ENCRYPTION_KEY = 'turnserversecret';
const getIceServerConfig = (env = constants_1.default.ENV.PROD) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
    const apiEndpoint = `${API_BASE_URL}/v1/turnserver/iceconfig`;
    const { data: encryptedData } = yield (0, axiosUtil_1.axiosGet)(apiEndpoint);
    const { config: decryptedData } = JSON.parse(CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8));
    return decryptedData;
});
exports.getIceServerConfig = getIceServerConfig;
//# sourceMappingURL=getIceServerConfig.js.map